<template>
  <div class="nodata-wrap g-flex-c">
    <img src="https://web.nlktj.com/ty/merchant/nodata.png" alt="">
    <p>您还没有参与任何活动哦</p>
    <template v-if="showButton">
      <el-button v-if="haveInterest" @click="$router.push({path: '/marketCenter/marketHelper'})">立即参加</el-button>
      <el-button type="primary" size="medium" @click="$router.push({path: '/marketShop/shopCenter'})" v-else>立即购买</el-button>
    </template>
  </div>
</template>
<script>
export default {
  name: 'noData',
  props: {
    haveInterest: Boolean,
    showButton: Boolean
  }
}
</script>
<style lang="less" scoped>
  .nodata-wrap {
    height: 100%;
    flex-direction: column;
    img {
      width: 193px;
      height: 186px;
    }
  }
</style>